import { Data2, newId, dateToString } from '../../../features/data-types'
import { DataTypeEvent } from '../../../features/events'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { DeliveryData, DeliveryStatus } from '../../deliveries'
import { FiscalDocumentStatus, Perception } from '../../fiscal-documents'
import { Item, PaymentStatus } from '../../operations'
import { useSystemStateHooks } from '../../system'
import { InternalNote, SaleOrder, SalePaymentItem } from '../state/types'

export const useSaleBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildSale = (data: Data2) => {
        const {
            id = newId(),
            code,
            creationDate,
            items,
            paymentTypeId,
            paymentTypeYield,
            paymentItems,
            paidAmount,
            receivedAmount,
            overpaidAmount,
            adjustedAmount,
            sellerId,
            customerId,
            customerTypeId,
            initialCredit,
            deliveryData,
            deliveryStatus,
            paymentStatus,
            invoiceStatus,
            branchId,
            latePayment,
            notes,
            events,
            perceptions,
            internalNotes,
            cancelled,
            archived
        } = data

        const sale: SaleOrder = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            codeStr: code!.toString()!,
            creationDate: dateToString(creationDate || new Date())!,
            items: (items || []) as Item[],
            currency: Currency.ARS,
            paymentTypeId: paymentTypeId! as string,
            paymentTypeYield: paymentTypeYield! as number,
            paymentItems: (paymentItems || []) as SalePaymentItem[],
            paidAmount: (paidAmount || 0) as number,
            receivedAmount: receivedAmount as O<number>,
            overpaidAmount: overpaidAmount as O<number>,
            adjustedAmount: adjustedAmount as O<number>,
            sellerId: sellerId! as string,
            customerId: customerId! as string,
            customerTypeId: customerTypeId! as string,
            initialCredit: initialCredit as O<number>,
            deliveryData: deliveryData as O<DeliveryData>,
            deliveryStatus: (deliveryStatus || DeliveryStatus.PENDING) as DeliveryStatus,
            paymentStatus: (paymentStatus || PaymentStatus.PENDING) as PaymentStatus,
            invoiceStatus: (invoiceStatus || FiscalDocumentStatus.PENDING) as FiscalDocumentStatus,
            branchId: branchId! as string,
            latePayment: !!latePayment as boolean,
            notes: notes as O<string>,
            events: (events || []) as DataTypeEvent[],
            perceptions: (perceptions || []) as Perception[],
            internalNotes: (internalNotes || []) as InternalNote[],
            cancelled: !!cancelled,
            archived: !!archived
        }

        return sale
    }

    return {
        buildSale
    }
}
